import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import mask from '@alpinejs/mask'
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import EffectMaterial from './effect-material.esm.js';

import 'swiper/css';
import 'swiper/css/effect-fade';

Swiper.use([Autoplay, EffectFade, Navigation, EffectMaterial]);
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
Alpine.plugin(mask);
Alpine.plugin(collapse);

// Components

// Global
window.Swiper = Swiper;
window.Alpine = Alpine;
window.gsap = gsap;
window.ScrollToPlugin = ScrollToPlugin;
window.ScrollTrigger = ScrollTrigger;
window.EffectMaterial = EffectMaterial;

// Inits
Alpine.start();